import classNames from "classnames"

import { Category } from "@doktor-se/bones-ui/dist/web-shared/types"

import styles from "./CategoryBadge.module.scss"

interface SymptomBadgeProps {
  category?: Pick<Category, "name" | "image">
}

const SymptomBadge = ({ category }: SymptomBadgeProps): JSX.Element => {
  return (
    <div className={classNames(styles.container, styles.wrapper, styles.icon)}>
      <img
        className={classNames(styles.icon, styles.filteredImg)}
        src={`${import.meta.env.VITE_APP_APP_STATIC}/${!!category ? category.image : "symptom/other"}.png`}
        alt={category?.name}
      />
    </div>
  )
}

export default SymptomBadge
